import mobiscroll from "@mobiscroll/react";
import * as Sentry from '@sentry/browser';
import { mpoSentry } from './Sentry';
import {isCordova, openWindow} from '../shared/utility';

const isCustomApp = process.env.REACT_APP_CUSTOM_APP === 'true';

export const mpoAppStore = {

    getAppDownloadInfo: () => {
        let downloadAppUrl = "";
        let downloadAppIcon = "empty icon fas ";
        const downloadAppText = "Download our App";
        if (!isCordova()) {
            if (mobiscroll.platform.name === 'ios') {
                downloadAppUrl = process.env.REACT_APP_ITUNES_APP_URL;
                downloadAppIcon += "fa-apple";
            } else if (mobiscroll.platform.name === 'android') {
                downloadAppUrl = process.env.REACT_APP_GOOGLE_APP_URL;
                downloadAppIcon += "fa-google-play";
            }
        }
        return {
            downloadAppUrl: downloadAppUrl,
            downloadAppIcon: downloadAppIcon,
            downloadAppText: downloadAppText
        };
    },

    inviteUserToDownloadApp: (msg, url) => {

        if (msg !== "" && url !== "") {
            mobiscroll.confirm({
                title: 'Download our App',
                message: msg,
                okText: 'Download',
                cancelText: 'No Thanks'
            }).then((res) => {
                if (res) {
                    mpoAppStore.downloadApp(url);
                    mpoSentry.addBreadcrumb('appstore','Accepted to download app',Sentry.Severity.Info);
                } else {
                    mpoSentry.addBreadcrumb('appstore','Declined to download app',Sentry.Severity.Info);
                }
            });
        }

    },

    downloadApp: (url) => {
        if (typeof window !== "undefined") {
            openWindow(url, '_system', '', isCustomApp);
        } else {
            mobiscroll.alert({
                title: 'App Download',
                message: 'Unable to open your App Store'
            });
        }
    },

    inviteUserToReviewApp: (msg, url) => {

        if (msg !== "" && url !== "") {
            mobiscroll.confirm({
                title: 'Review our App',
                message: msg,
                okText: 'Review',
                cancelText: 'No Thanks'
            }).then((res) => {
                if (res) {
                    mpoAppStore.reviewApp(url);
                    mpoSentry.addBreadcrumb('appstore','Accepted to review app',Sentry.Severity.Info);
                } else {
                    mpoSentry.addBreadcrumb('appstore','Declined to review app',Sentry.Severity.Info);
                }
            });
        }

    },

    reviewApp: (url) => {
        if (typeof window !== "undefined") {
            openWindow(url, '_system', '', isCustomApp);
        } else {
            mobiscroll.alert({
                title: 'App Review',
                message: 'Unable to open your App Store'
            });
        }
    }

}